import React, {FC} from "react";
import Button from "@mui/material/Button";
import {VasIcon} from "./Icons";

type VasButtonProps = {
   url: string
}

/**
 * Bordered button that opens the VAS system in a new tab.
 * Shared between pages so the VAS entry-point has the same look everywhere.
 */
export const VasButton: FC<VasButtonProps> = ({url}) => {
   return <Button variant={"outlined"} startIcon={<VasIcon/>}
                  onClick={() => window.open(url, '_blank')}>
      VAS
   </Button>
}
